export default __webpack_public_path__ + "images/54ff68f6e19fcc48978232f2824156d1.svg";